import Head from 'next/head';
import { AuthenticationLayout } from '@Components/AppLayout';
import { SignUpController } from '@Views';
import { UserTypeEnum } from '@Types';
import { useRouter } from '@Helpers/useRouter';
import { useSetHotjar } from '@Hooks/useSetHotjar';

const MAP_USER_TYPES = {
  group: UserTypeEnum.GROUP,
  funder: UserTypeEnum.FUNDER,
};

const SignUpPage = () => {
  const { getSingleValueParam } = useRouter();

  let userType: UserTypeEnum | undefined;

  const type = getSingleValueParam('type');
  const nominationToken = getSingleValueParam('nomination');
  const defaultOrganizationName = getSingleValueParam('organizationName');
  const defaultEmail = getSingleValueParam('email');

  if (typeof type === 'string' && ['group', 'funder'].includes(type)) {
    userType = MAP_USER_TYPES[type as 'group' | 'funder'];
  }

  useSetHotjar();

  return (
    <AuthenticationLayout>
      <Head>
        <title>{`Sign up | ActionFunder`}</title>
      </Head>
      <SignUpController
        userType={userType}
        nominationToken={nominationToken}
        defaultOrganizationName={defaultOrganizationName}
        defaultEmail={defaultEmail}
      />
    </AuthenticationLayout>
  );
};

export default SignUpPage;
